import React from 'react';
import {EditorDraf} from 'components/partials/editor';
import {Input, Textarea, RichTextarea} from 'components/vitrade-forms/common';
import {SubCategorySelectorInput} from 'components/vitrade-forms';
import {Checkbox} from 'components/partials/checkbox';
import {Select} from 'components/partials/select';
import {Link, withRouter} from 'react-router-dom';
import style from 'components/my-business/manage-product/style.scss';
import {MultipleImageUploader} from 'components/uploader';
import {Products} from 'api';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';
import {ShowIf} from 'components/utils';

class AddFairProduct extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formPostProduct'] = [];

    this.state = {
      name: 'Trà xanh',
      code: '',
      price: this.props.defaultPrice,
      description: '',
      introduction: '',
      images: [],
      categoryIds: [],
      businessId: null,
      ShowProduct: false
    }
  }

  onChange(name, e) {
    if (name == 'typePrice') {
      if (this.state.typePrice == 'price') {
        this.setState({
          [name]: 'contact'
        })
      } else {
        this.setState({
          [name]: 'price'
        })
      }
    } else {
      this.setState({
        [name]: e.target.value
      })
    }
  }

  onUploadComplete(images) {
    this.setState({
      images
    });
  }

  onChange(name, e) {
    let val = e.target ? e.target.value : e;
    this.setState({
      [name]: val
    })
  }

  submitForm(e) {
    e.preventDefault();
    //do something
    return false;
  }

  selectRadio(type) {
    if (type == 'sell') {
      this.setState({
        ShowProduct: false
      });
    } else {
      this.setState({
        ShowProduct: true
      });
    }
  }

  selectCategories(value) {
    let categoryIds = [];
    value.map(item => {
      categoryIds.push(item.value);
    });

    this.setState({
      categoryIds
    });
  }

  selectCategoriesOther(value) {
    let categoryIds = [];
    value.map(item => {
      categoryIds.push(item.value);
    });

    this.setState({
      categoryIds
    });
  }

  render() {
    return (
      <section className="add-product">
        <h2 className='add-product-title'>Thêm sản phẩm cho hội chợ</h2>
        <form onSubmit={this.submitForm.bind(this)}>
          <div className='add-product-wrap-form'>
            <div className='add-product-left-content'>
              <Input type="text" placeholder="Tên sản phẩm..."
                className='has-feedback fg-custom mb15'
                iconFontSet='vtd-product'
                iconClassName='input-product-name-icon'
                value={this.state.name}
                required={"Tên sản phẩm không được để trống"}
                onChange={this.onChange.bind(this, 'name')}
                bindValidator={this} channel="formPostProduct"
                errorMessage="Tên sản phẩm không được để trống"
              />
              <MultipleImageUploader fnUpload={Products.actions.upload.request}
                type='PRODUCT'
                heading ='Ảnh đại diện của sản phẩm'
                onUploadComplete={this.onUploadComplete.bind(this)}
              />

              <MultipleImageUploader fnUpload={Products.actions.upload.request}
                type='PRODUCT'
                heading ='Album hình ảnh của sản phẩm'
                onUploadComplete={this.onUploadComplete.bind(this)}
              />

              <Textarea type="text" placeholder="Mô tả..."
                heading={
                  () => <h3 className='wrap-product-des-title'>Mô tả ngắn <span className='des-title-des'><i className='fa fa-info-circle'/>Giới hạn trong 100 chữ.</span></h3>
                }
                className='wrap-product-des'
                inputClassName='product-des-input'
                iconFontSet='glyphicon'
                iconClassName='glyphicon-user'
                value={this.state.description}
                onChange={this.onChange.bind(this, 'description')}
                required={true}
                bindValidator={this} channel="formPostProduct"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"
              />

              <RichTextarea type="text" placeholder="Mô tả..."
                heading={
                  () => <h3 className='wrap-product-des-title'>Giới thiệu về sản phẩm</h3>
                }
                className='wrap-product-des'
                inputClassName='product-des-input'
                iconFontSet='glyphicon'
                iconClassName='glyphicon-user'
                value={this.state.introduction}
                onChange={this.onChange.bind(this, 'introduction')}
                required={true}
                bindValidator={this} channel="formPostProduct"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"
              />
            </div>

            <div className='add-product-right-content'>

              <div className='wrap-radio-price pb5'>
                <h3 className='wrap-radio-price-title'>Loại</h3>
                <div className='wrap-input-radio-price'>
                  <input className='input-radio-price' id="ShowProduct" type='radio' onChange={this.selectRadio.bind(this, 'show')} checked={this.state.ShowProduct} name='product-price'/>
                  <label className='label-radio-price' htmlFor="ShowProduct">Hàng trưng bày</label>
                </div>
                <div className='wrap-input-radio-price'>
                  <input className='input-radio-price' type='radio' id="SellProduct" onChange={this.selectRadio.bind(this, 'sell')} checked={!this.state.ShowProduct} name='product-price'/>
                  <label className='label-radio-price' htmlFor="SellProduct">Hàng bán</label>
                </div>
              </div>
              <div className='wrap-radio-price'>
                <SubCategorySelectorInput label="Nhóm sản phẩm"
                  onChange={this.selectCategories.bind(this)}
                />
              </div>
              <div className='wrap-radio-price'>
                <SubCategorySelectorInput label="Nhóm sản phẩm khác"
                  onChange={this.selectCategoriesOther.bind(this)}
                />
              </div>
              <div className='wrap-radio-price mb35'>
                <h3 className='wrap-radio-price-title'>Giá sản phẩm</h3>
                <div className='mb20'>
                  <input className='input-price' onChange={this.onChange.bind(this, 'price')}/>
                </div>
                <h3 className='wrap-radio-price-title'>Giảm giá theo</h3>
                <div className='mb20 input-fair-sale'>
                  <Select/>
                </div>
                <div className='wrap-product-sale mb20'>
                  <input className='product-sale-input'/>
                  <p className='product-sale-unit pr10 pl5'>%</p>
                  <p className='product-sale-result'>Giảm: 1.500.000 VNĐ</p>
                </div>
                {
                  this.props.edit ?
                    (
                      <div className='add-product-btn-wrap'>
                        <button className='add-product-btn'>Cập nhật sản phẩm</button>
                      </div>
                    ):(
                      <div className='add-product-btn-wrap'>
                        <button className='add-product-btn'>Đăng sản phẩm</button>
                      </div>
                    )
                }
              </div>

              {
                this.props.edit ? (
                  <button className='btn-delete-product'><i className='fa fa-trash'/>Xóa sản phẩm</button>
                ) : null
              }
            </div>
          </div>
        </form>
      </section>
    );
  }
}


AddFairProduct.defaultProps = {
  validators: {},
  defaultPrice: 'Giá tham khảo'
}

const bindStateToProps = state => {
  return {
    auth: state.auth,
    businesses: state.myBusinesses
  }
}

export default withRouter(connect(bindStateToProps)(AddFairProduct));



// WEBPACK FOOTER //
// ./components/my-business/sub-view/fair/AddFairProduct.jsx